import { Component, OnInit } from '@angular/core';
import { KMTMessage } from '@core/models/global-entities/messages';
import { MessagingStoreService } from '@core/services/messaging-store.service';

@Component({
  selector: 'kmt-message-sidebar',
  templateUrl: './message-sidebar.component.html',
})
export class MessageSidebarComponent implements OnInit {
  messages: KMTMessage[] = [];
  constructor(private messageStore: MessagingStoreService) {}

  ngOnInit(): void {
    this.messageStore.MessageCacheChanged.subscribe(() => {
      this.messages = this.messageStore.getMessages();
    });
  }
}
